import { GET_COST_SEARCH_DEFAULT_SELECTIONS } from '../../globalConfig/constants'

export const reducer = (state, action) => {
  switch (action.type) {
    case 'update_cost_search_criteria':
      return {
        costSearchCriteria: action.costSearchCriteria,
      }

    default:
      return state
  }
}

export const initialState = {
  costSearchCriteria: GET_COST_SEARCH_DEFAULT_SELECTIONS(),
}
